module.exports = __webpack_public_path__ + "static/media/GUIDE_0009_01.3a7567b7.webp";